import { matchAll } from 'web-services/utils/regex';

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _createForOfIteratorHelper(o) {
  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) {
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var it,
      normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var LOCALIZED_DATETIME_HANDLEBARS_REGEX_PATTERN = /{{(localizedDate|localizedTime|localizedDayOfWeek) [0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}Z}}/; // eslint-disable-line

/**
 * Replaces {{localizedDate <date>}} and {{localizedTime <time>}} with localized date and time values
 * e.g. {{localizedDate 2020-01-29T00:00:00Z}} gets replaced with 'January 2nd'.
 * The standard localized date and time output formats we use are, e.g., "9:30 PM (PST)" and "Sunday, October 18th".
 * NOTE: the input datetimes must be in ISO format MINUS the milliseconds.
 * @param {*} text The text to update with localized datet and time replacements.
 */

function replaceWithLocalizedDateTimes(text) {
  var newText = text; // This needs to be localized to the client so we just want the replace to happen client side

  if (text && typeof window !== 'undefined') {
    // If we end up adding more client side handlebars, we may want to consider adding a library
    // to handle them in the future, for now that seems like overkill for the limited scope
    var handlebarsToLocalize = matchAll(LOCALIZED_DATETIME_HANDLEBARS_REGEX_PATTERN, text);
    var date = null;
    var dateType = '';
    var dateString = '';
    var replacement = '';
    var dateLocalizationOptions = {
      day: 'numeric',
      month: 'long'
    };

    if (window.Cypress) {
      dateLocalizationOptions.timeZone = 'UTC';
    }

    var _iterator = _createForOfIteratorHelper(handlebarsToLocalize),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var dateToLocalize = _step.value;
        replacement = '';
        var parts = dateToLocalize[0].replace(/(\{|\})+/g, '').split(' ');

        if (parts.length < 2) {
          // This is an invalid handlebar for date formatting
          continue;
        }

        dateType = parts[0];
        dateString = parts[1];
        date = new Date(dateString);

        if (dateType === 'localizedDate') {
          // We need to replace this with the month and day -- January 2nd
          replacement = "".concat(date.toLocaleDateString('en-US', dateLocalizationOptions)) + "".concat(getDateSuffix(date.getDate()));
          newText = newText.replace(dateToLocalize[0], replacement);
        } else if (dateType === 'localizedTime') {
          // We need to replace this with the format h:mma (z) -- 7:42am (PST)
          replacement = formatTime(date);
          newText = newText.replace(dateToLocalize[0], replacement);
        } else if (dateType === 'localizedDayOfWeek') {
          // We need to replace this with the string fro the day of week -- Wednesday
          replacement = getDayOfWeekString(date.getDay());
          newText = newText.replace(dateToLocalize[0], replacement);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return newText;
}
/**
 * Gets the ordinal suffix for the date by number
 * -- returns the suffix only
 */


function getDateSuffix(number) {
  var s = ['th', 'st', 'nd', 'rd'];
  var v = number % 100;
  return s[(v - 20) % 10] || s[v] || s[0];
}
/**
 * Returns the long string for the day of the week
 * @param {*} day 0-6 where 0 is Sunday
 */


var getDayOfWeekString = function getDayOfWeekString(day) {
  var strings = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  return strings[day];
};
/** Formats a Date object into our standard time format.
 * e.g. 8:00PM (PST)
 * @param date Date object
 */


function formatTime(date) {
  var timeLocalizationOptions = {
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short'
  };

  if (window.Cypress) {
    timeLocalizationOptions.timeZone = 'UTC';
  } // We need to replace this with the format h:mma (z) -- 7:42am (PST)


  var timeParts = date.toLocaleTimeString('en-US', timeLocalizationOptions).split(' ');
  return "".concat(timeParts[0]).concat(timeParts[1], " (").concat(timeParts[2], ")");
}

export { formatTime, replaceWithLocalizedDateTimes };